import React, { useRef } from "react";

import { Icon } from "../../../../Elements/Icon";
import { CurrentTrack } from "./CurrentTrack";
import { TrackList } from "./TrackList";

import * as styles  from "./styles.module.scss";

export const Expanded = ({
    guide,
    language,
    version,
    track,
    setLanguage,
    setVersion,
    onToggle,
}) => {
    const ref = useRef();

    return (
        <div className={styles.expanded}>
            <div className={styles.toggle}>
                <button
                    type="button"
                    className={styles.handle}
                    onClick={onToggle}
                >
                    <Icon name="chevron-down" width="18" height="16" />
                </button>
            </div>

            <div ref={ref} className={styles.content}>
                <CurrentTrack
                    guide={guide}
                    language={language}
                    version={version}
                    track={track}
                    setLanguage={setLanguage}
                    setVersion={setVersion}
                />

                <TrackList
                    current={track?.number}
                    tracks={version.tracks}
                />
            </div>
        </div>
    );
};
